import { render } from "./AddSimpleBranch.vue?vue&type=template&id=7d68d640&scoped=true"
import script from "./AddSimpleBranch.vue?vue&type=script&lang=js"
export * from "./AddSimpleBranch.vue?vue&type=script&lang=js"

import "./AddSimpleBranch.vue?vue&type=style&index=0&id=7d68d640&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d68d640"]])

export default __exports__